import React from 'react';
import {useDropzone} from "react-dropzone";
import Grid from "@material-ui/core/Grid";
import styled from "styled-components";
import uploadImage from "../../img/upload-image.png";
import {Colors} from "../../theme/colors";
import {CustomCloseModalIcon} from "../ui-base/icons/custom-close-modal-icon";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";

const UploadDropzone = (
	{
		setFieldValue,
		values,
		description,
		fieldName,
		inputAccept,
		initialValue,
		setInitialValue,
		info,
		error,
		wrongFormatError = false
	}
) => {
	const {getRootProps, getInputProps} = useDropzone({multiple: false});
	const {t} = useTranslation(['author', 'common']);

	return (
		<StyledUploadDropzone {...getRootProps({className: 'dropzone'})} container direction={"column"}>
			<StyledInfoContainer>
				<Tooltip title={info}>
					<InfoOutlinedIcon style={{fill: Colors.lightViolet}}/>
				</Tooltip>
			</StyledInfoContainer>
			<Grid item container direction={"column"} justifyContent={"center"} alignItems={"center"} spacing={2}>
				<input
					{...getInputProps()}
					accept={inputAccept}
					id={fieldName}
					name={fieldName}
					onChange={(event) => {
						setFieldValue(fieldName, event.target.files[0]);
					}}
				/>

				{(!values[fieldName]?.name && !initialValue) &&
                    <>
                        <Grid item>
                            <StyledImg src={uploadImage}/>
                        </Grid>
                        <Grid item>
                            <StyledP>{description}</StyledP>
                        </Grid>
                    </>
				}

				{(values[fieldName]?.name || initialValue) &&
                    <>
                        <Grid item>
                            <StyledPAdded>{t('uploadDropzone.addedFile')}:</StyledPAdded>
                        </Grid>
                        <Grid item container direction={"row"} alignItems={"center"} justifyContent={"center"}>
                            <StyledFileSelected item>
                                <Grid item container direction={"row"}>
                                    <Grid item>
                                        <StyledFileP>
											{initialValue ? initialValue : values[fieldName]?.name}
                                        </StyledFileP>
                                    </Grid>

                                    <Grid item style={{marginTop: '1px', height: '18px'}}>
                                        <CustomCloseModalIcon
                                            style={{fontSize: '18px', height: '18px', width: '18px'}}
                                            onClick={(event) => {
												event.stopPropagation();

												setFieldValue(fieldName, null);
												if (setInitialValue) {
													setInitialValue(null);
												}
											}}
                                        />
                                    </Grid>
                                </Grid>
                            </StyledFileSelected>
                        </Grid>
                    </>
				}

				{error &&
                    <StyledErrorP>{t('uploadDropzone.error')}</StyledErrorP>
				}
				{wrongFormatError &&
                    <StyledErrorP>{t('common:wrongFileFormat')}</StyledErrorP>
				}
			</Grid>
		</StyledUploadDropzone>
	);
}

export default UploadDropzone;

const StyledUploadDropzone = styled(Grid)`
  background: #FBF5FF;
  border: 1px dashed #6714A3;
  box-sizing: border-box;
  box-shadow: inset 1px 2px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  position: relative;
`;

const StyledInfoContainer = styled(Grid)`
  position: absolute;
  top: 5px;
  right: 5px;
`;

const StyledP = styled('p')`
  color: ${Colors.lightViolet};
  font-size: 1.2rem;
  font-weight: 500;
  text-align: center;
  margin-bottom: 1rem;
`;

const StyledPAdded = styled('p')`
  color: ${Colors.lightViolet};
  font-size: 1.2rem;
  font-weight: 500;
  text-align: center;
  margin-top: 1rem;
`;

const StyledImg = styled('img')`
  margin-top: 1rem;
`;

const StyledFileSelected = styled(Grid)`
  background: #FBF5FF;
  border: 1px solid #CCB1E0;
  box-sizing: border-box;
  border-radius: 20px;
  padding: 0.2rem 0.5rem;
  margin-bottom: 10px;
`;

const StyledFileP = styled('p')`
  color: ${Colors.lightViolet};
  margin-right: 10px;
  font-weight: 500;
`;

const StyledErrorP = styled('p')`
  color: #f44336;
  margin-bottom: 10px;
`;
